module.exports = __webpack_public_path__ + "./images/18d4f08e3a912fed1944ad36a2e90b1d.webp";